export class OnlineController {
    constructor($scope, $location, UserService, RegionService, $rootScope) {
        this.scope = $scope;
        this.location = $location;
        this.rootScope = $rootScope;
        this.UserService = UserService;
        this.RegionService = RegionService;

        this.init();
    }

    init() {
        this.scope.isLoadedPage = this.rootScope.content.location === this.location.path();
        this.scope.adsLimit = 5;
        this.scope.loading = false;
        this.scope.regions = [];
        this.filterLocation = this.location.search();
        this.scope.params = {};
        this.scope.params.filters = {
            region: this.filterLocation.region,
            filter_age: this.filterLocation.age
        };

        this.RegionService.getRegionsList()
            .then((response) => { let regions = response.data;
                this.scope.regions = regions.data;
            })
            .catch((response) => { let err = response.data;
                console.error(err);
            });

        this.scope.setFilter = () => {
            this.rootScope.content.page = 1;
            this.rootScope.content.items = [];
            this.loadMore();
        };

        this.scope.canLoadMore = () => {
            return this.rootScope.content.pageCount >= this.rootScope.content.page;
        };

        this.scope.loadMore = () => {
            this.loadMore();
        };

        if(this.rootScope.content.location !== this.location.path()) {
            this.rootScope.content.items = [];
            this.rootScope.content.page = 1;
            this.rootScope.content.pageCount = 0;
            this.rootScope.content.limit = 18;
            this.rootScope.content.maxItem = 0;
            this.rootScope.content.location = this.location.path();

            this.UserService.getCurrentUser()
                .then((response) => { let user = response.data;
                    this.rootScope.currentUserProfile = user.data;
                })
                .catch((response) => { let err = response.data;
                    console.error(err);
                });

            this.loadMore();
        }
    }

    loadMore() {
        if(this.scope.loading) return;
        this.scope.loading = true;
        let filterAge = this.scope.params.filters.filter_age;
        let filterRegion = this.scope.params.filters.region;
        let filterPhoto = this.scope.params.filters.photo;
        let getAge = this.getFilterAge(filterAge);
        let thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
        this.location.search('region', filterRegion);
        this.location.search('age', filterAge);
        this.location.search('photo', filterPhoto);

        let request = {
            isPhoto: +filterPhoto,
            age: getAge
        };

        if (filterRegion) {
            request.region = filterRegion;
        }

        this.UserService.getOnlineUsers(JSON.stringify(request), this.rootScope.content.page, this.rootScope.content.limit)
            .then((_res) => { let response = _res.data;
                this.rootScope.content.maxItem = response.itemCount;
                this.rootScope.content.pageCount = response.pageCount;
                if(!this.rootScope.isVip()) {
                    let period = 9;
                    let countAds = Math.floor(response.data.length / period);
                    //insert ads after period
                    for(let i = 0; i < countAds; i++) {
                        if(this.scope.adsLimit > 0 && (i != 0 || this.rootScope.content.page != 1)) {
                            response.data.splice(i * period, 0, {_id: Date.now() + i, banner: true});
                            this.scope.adsLimit--;
                        }
                    }
                }
                this.rootScope.content.items = this.rootScope.content.items.concat(response.data);
                this.rootScope.content.items = _.uniqBy(this.rootScope.content.items, item => item._id);
                this.rootScope.content.page++;
                this.scope.isLoadedPage = true;
                this.scope.loading = false;
            })
            .catch((response) => { let err = response.data;
                this.scope.isLoadedPage = true;
                this.scope.loading = false;
                console.error(err);
            });
    }

    getFilterAge(param) {
        switch (param) {
            case '1': return {from: 18, to: 25};
            case '2': return {from: 26, to: 35};
            case '3': return {from: 36, to: 44};
            case '4': return {from: 45, to: 100};
            default: return {from: 18, to: 100};
        }
    }
}
